import { render } from "./UploadQueue.vue?vue&type=template&id=27d33de8&scoped=true"
import script from "./UploadQueue.vue?vue&type=script&lang=js"
export * from "./UploadQueue.vue?vue&type=script&lang=js"

import "./UploadQueue.vue?vue&type=style&index=0&id=27d33de8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d33de8"]])

export default __exports__